import { IconButton, TextField } from "@suraasa/placebo-ui"
import Navbar from "components/Navbar"
import PageContainer from "components/PageContainer"
import { ArrowRight } from "iconoir-react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { routes } from "utils/routes"

type Form = {
  id: string
}

const Home = () => {
  const navigate = useNavigate()

  const form = useForm<Form>()

  const onSubmit = form.handleSubmit(values => {
    navigate(routes.user.replace(":userId", values.id))
  })

  return (
    <>
      <Navbar />
      <PageContainer className="my-4 pb-5">
        <form
          className="flex items-start justify-center gap-1"
          onSubmit={onSubmit}
        >
          <TextField
            label="Enter User ID"
            errors={form.formState.errors?.id}
            {...form.register("id", { required: "Required" })}
          />
          <IconButton
            variant="filled"
            size="md"
            type="submit"
            className="mt-[26px]"
          >
            <ArrowRight />
          </IconButton>
        </form>
      </PageContainer>
    </>
  )
}

export default Home
